// @flow

import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../../stylesheets';
import { Row, Col, Avatar, Card, Icon, Loading } from '../';
import { getHash, __tail, delIdx } from '../../../utils';
import { removeMedia, handleError } from '../../../services';
import { Uploader } from './Uploader';
import { UploaderCard } from './UploaderCard';

type Props = {
  onSetFile: Function,
  initialSrc?: Array,
  onRemoveFile?: Function,
};

const ImageUploader = ({
  onSetFile,
  initialSrc = [],
  onRemoveFile = () => {},
}: Props) => {
  const [imageFileArray, setImageFileArray] = useState(initialSrc);
  const [imageSrc, setImageSrc] = useState(initialSrc);
  const [loading, setLoading] = useState(null);

  const setFile = (e) => {
    const srcReader = new FileReader();
    srcReader.onloadend = () => setImageSrc([...imageSrc, srcReader.result]);

    if (e.target.files[0] && e.target.files[0] instanceof Blob)
      srcReader.readAsDataURL(e.target.files[0]);

    setImageFileArray([...imageFileArray, e.target.files[0]]);
    onSetFile([...imageFileArray, e.target.files[0]]);
  };

  const removeFile = async (i) => {
    if (imageSrc[i]) {
      if (typeof imageFileArray[i] === 'string') {
        setLoading(i);
        const hh = getHash(imageFileArray[i]);
        if (!hh) return '';
        await removeMedia(hh)
          .then((res) => {
            onRemoveFile(res);
            setImageSrc(delIdx(imageSrc, i));
            setImageFileArray(delIdx(imageFileArray, i));
            onSetFile(delIdx(imageFileArray, i));
          })
          .catch(handleError)
          .finally(() => setLoading(null));
      } else if (typeof imageFileArray[i] === 'object') {
        setImageSrc(delIdx(imageSrc, i));
        setImageFileArray(delIdx(imageFileArray, i));
        onSetFile(delIdx(imageFileArray, i));
      }
    }
    setLoading(false);
  };

  return (
    <div className="container-fluid overflow-auto">
      <Row className="position-relative">
        <Col
          xs={4}
          className="d-flex align-items-center justify-content-center"
        >
          <Card
            className="position-relative d-flex justify-content-center align-items-center px-2"
            type="lighterGray"
            width="60px"
            height="60px"
          >
            <Uploader type="file" accept="image/*" onChange={setFile} />
            <UploaderCard>
              <Icon name="zoom" size={16} color="blackText" />
            </UploaderCard>
          </Card>
        </Col>
        {[...Array(imageSrc.length > 8 ? imageSrc.length : 8)].map(
          (item, i) => (
            <Col
              xs={4}
              className="p-1 d-flex align-items-center justify-content-center"
              key={i}
            >
              <Avatar
                className="h-100"
                src={
                  imageSrc[i] && imageSrc[i].length
                    ? imageSrc[i]
                    : '/images/imagePlaceholder.png'
                }
                hasRemove={imageSrc[i] && imageSrc[i].length}
                onClickRemove={() => removeFile(i)}
                loading={loading === i}
              />
            </Col>
          )
        )}
      </Row>
    </div>
  );
};
export { ImageUploader };
